import React from 'react';
import { observer } from 'mobx-react';
import { OEToggle } from '../../oe-toggle/oe-toggle';
import { InfoPopover } from '../../info-popover/info-popover';

interface IProps {
    isSelected: boolean;
    toggle: () => void;
    text: string | JSX.Element;
    isDisabled?: boolean;
    popoverText?: string | JSX.Element;
    className?: string;
    overrideDefaultClassName?: boolean;
}

export const FormFieldInputToggle = observer(({
    isSelected, toggle, isDisabled, text, popoverText, className, overrideDefaultClassName
}: IProps): JSX.Element => {
    const defaultClassName = 'm-bottom-20px flex';

    return (
        <div className={`${overrideDefaultClassName ? '' : defaultClassName} ${className ? className : ''}`}>
            <OEToggle
                isSelected={isSelected}
                onClick={toggle}
                isDisabled={isDisabled}
            />
            {text}
            {!!popoverText && (
                <InfoPopover className='p-left-5px'>
                    <div>{popoverText}</div>
                </InfoPopover>
            )}
        </div>
    );
});
